"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQueryParamSynched = void 0;
var qs_1 = __importDefault(require("qs"));
var react_1 = require("react");
var react_2 = require("react");
function useQueryParamSynched(qpParamName, initialValue) {
    var qpValue = qs_1.default.parse(window.location.search.substring(1))[qpParamName];
    var _a = react_2.useState(qpValue !== null && qpValue !== void 0 ? qpValue : initialValue), value = _a[0], setValue0 = _a[1];
    var setValue = react_1.useCallback(function (value) {
        var qp = qs_1.default.parse(window.location.search.substring(1));
        qp[qpParamName] = value;
        window.history.replaceState({}, "", "?" + qs_1.default.stringify(qp));
        setValue0(value);
    }, [setValue0, qpParamName]);
    return [value, setValue];
}
exports.useQueryParamSynched = useQueryParamSynched;
